import { FiEdit } from "react-icons/fi";
import { NavLink } from "react-router-dom";
export default ({ products, isAdmin, query }) => {
  // {
  // console.log("query", query);
  // }
  // console.log("pr", products);

  return (
    <>
      {isAdmin && (
        <div
          className="text-light d-inline edit-icon m-2 p-1"
          style={{ backgroundColor: "navy", fontSize: "14px" }}
          data-bs-toggle="modal"
          data-bs-target="#editSpecialProductModal"
        >
          <FiEdit className=" mx-1"></FiEdit>
          ویرایش
        </div>
      )}

      <div className="d-flex flex-wrap ">
        {query.map((value, index) => {
          // let configs = query[index].replace("@@", "");
          return (
            <SpecialProduct
              source={value.source}
              config={value.querys}
              // source={products[index].source}
              // config={value.split("@@")[1]}
            ></SpecialProduct>
          );
        })}
      </div>
    </>
  );
};

function SpecialProduct({ source, config }) {
  // console.log("sss", source);
  return (
    <div className="col-6 col-sm-3  special-product my-2">
      <NavLink to={`/${config}`} target="_blank">
        <img
          className=" w-100 h-100 rounded px-2"
          src={`http://grc.tatdemo.ir/${source}`}
        ></img>
      </NavLink>
    </div>
  );
}
